"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.symbol.async-iterator.js");

require("core-js/modules/es.symbol.to-string-tag.js");

require("core-js/modules/es.json.to-string-tag.js");

require("core-js/modules/es.math.to-string-tag.js");

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerStreamer = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.concat.js");

var _playlistAudioTrack = require("../playlistAudioTrack");

var _utils = require("../utils");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * Basic audio utilities for playing speakers audio
 * @export
 * @class SpeakerPlayer
 */
var SpeakerStreamer = /*#__PURE__*/function () {
  /**
   * Creates an instance of SpeakerPlayer.
   * @param {string} url URL of the audio
   * @memberof SpeakerPlayer
   */
  function SpeakerStreamer(_ref) {
    var _this = this;

    var audioContext = _ref.audioContext,
        uri = _ref.uri,
        id = _ref.id,
        config = _ref.config;

    _classCallCheck(this, SpeakerStreamer);

    _defineProperty(this, "playing", false);

    _defineProperty(this, "fading", false);

    _defineProperty(this, "isSafeToPlay", false);

    _defineProperty(this, "loaded", true);

    _defineProperty(this, "loadedPercentage", 100);

    _defineProperty(this, "_alreadyTryingToPlay", false);

    _defineProperty(this, "_fadingDestination", 0);

    _defineProperty(this, "_fading", false);

    _defineProperty(this, "started", false);

    this._context = audioContext;
    this.id = id;
    this.audio = new Audio();
    this.audio.crossOrigin = "anonymous";
    this.cleanUrl = (0, _utils.cleanAudioURL)(uri, false);
    this.config = config;
    this.audio.preload = "none";
    this.audio.src = _playlistAudioTrack.silenceAudioBase64;
    this.audio.load();
    this.audio.loop = true;
    this.audio.autoplay = false;
    this._audioSrc = this._context.createMediaElementSource(this.audio);
    this._gainNode = this._context.createGain();

    this._audioSrc.connect(this._gainNode);

    this._gainNode.connect(this._context.destination);

    this._gainNode.gain.value = 0; // initially 0 and fade later
    // -------------------------------------------
    // settings the play state

    this.audio.addEventListener("playing", function () {
      if (!_this.isSafeToPlay) return;
      _this.playing = true;

      _this.log("Playing event");
    });
    ["ended", "error", "pause", "about"].forEach(function (e) {
      _this.audio.addEventListener(e, function () {
        if (!_this.isSafeToPlay) return;
        _this.playing = false;

        _this.log("Pause event");
      });
    }); // -------------------------------------------

    this.audio.addEventListener("load", function () {
      _this.log("loading audio...");
    });
    this.audio.addEventListener("waiting", function () {
      _this.log("waiting to load... ".concat(_this.audio.src));
    });
    this._fadeDuration = 3;
  }

  _createClass(SpeakerStreamer, [{
    key: "log",
    value: function log(string) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (this.isSafeToPlay || force) && (0, _utils.speakerLog)("".concat(this.id, ": ").concat(string));
    }
  }, {
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isSafeToPlay) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                if (!this._alreadyTryingToPlay) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                if (!this.playing) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", true);

              case 6:
                _context.prev = 6;

                if (!(this._context.state !== "running")) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return this._context.resume();

              case 10:
                this._alreadyTryingToPlay = true;
                _context.next = 13;
                return this.audio.play();

              case 13:
                this._alreadyTryingToPlay = false;
                this.isSafeToPlay = true;
                this.log("Playing! Volume: ".concat(this.volume(), " ").concat(this.audio.src));
                return _context.abrupt("return", true);

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](6);
                this._alreadyTryingToPlay = false; // @ts-ignore

                this.log("failed to play, trying again. ".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message));
                return _context.abrupt("return", false);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 19]]);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: "fade",
    value: function fade() {
      var _this2 = this;

      var toVolume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._fadingDestination;
      var durationInSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._fadeDuration;
      if (this._fadingDestination === toVolume && this._fading) return;
      this._fadingDestination = toVolume; // assume it's already at the expected volume,
      // because there's always a small difference in decimals as gain.value is not accurate.

      if (Math.abs(this.volume() - this._fadingDestination) < 0.05) return;

      if (!this.playing || !this.isSafeToPlay) {
        console.log("scheduled to fade on audio starts playing");
        this.audio.addEventListener("playing", function () {
          _this2.log("fading...");

          _this2.fade();
        }, {
          once: true
        }); // schedule to fade when it starts playing.

        return;
      }

      (0, _utils.speakerLog)("".concat(this.id, ": startng fade ").concat(this.audio.volume, " -> ").concat(this._fadingDestination));

      this._gainNode.gain.cancelScheduledValues(0);

      this._fading = true;

      this._gainNode.gain.linearRampToValueAtTime(this._fadingDestination, this._context.currentTime + durationInSeconds);

      setTimeout(function () {
        (0, _utils.speakerLog)("".concat(_this2.id, ": volume faded to \"").concat(_this2.volume(), "\"\""));
        _this2._fading = false;
      }, durationInSeconds * 1000);
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.playing) {
        this.log("pausing from track");
        this.audio.pause();
      }

      this.playing = false;
    }
  }, {
    key: "fadeOutAndPause",
    value: function fadeOutAndPause() {
      var _this3 = this;

      if (!this.playing) return;
      if (this.volume() < 0.05) return this.pause();

      this._gainNode.gain.linearRampToValueAtTime(0, this._context.currentTime + this._fadeDuration);

      setTimeout(function () {
        // if audio was fading to something else
        // and couldn't managed to fade to 0 in 3 seconds, try again
        if (_this3.volume() > 0.05) _this3.fadeOutAndPause();else _this3.pause();
      }, this._fadeDuration * 1000);
    }
  }, {
    key: "volume",
    value: function volume() {
      return this._gainNode.gain.value;
    }
  }, {
    key: "timerStart",
    value: function timerStart() {
      var _this4 = this;

      if (this.started || this._alreadyTryingToPlay) return;
      var that = this;
      this.audio.src = _playlistAudioTrack.silenceAudioBase64;
      this.started = true;
      this._alreadyTryingToPlay = true;
      this.audio.play().then(function () {
        that.audio.src = that.cleanUrl;

        _this4.audio.addEventListener("loadedmetadata", function () {
          that.audio.currentTime = 0;
        }, {
          once: true
        });

        that.audio.pause();
        _this4._alreadyTryingToPlay = false;
        _this4.isSafeToPlay = true;
        that.log("Safe to play");
      });
    }
  }, {
    key: "timerStop",
    value: function timerStop() {}
  }, {
    key: "onLoadingProgress",
    value: function onLoadingProgress(callback) {
      callback(100);
    }
  }, {
    key: "onEnd",
    value: function onEnd(callback) {
      this.audio.onended = callback;
    }
  }, {
    key: "replay",
    value: function replay() {
      this.audio.currentTime = 0;
    }
  }]);

  return SpeakerStreamer;
}();

exports.SpeakerStreamer = SpeakerStreamer;